// extracted by mini-css-extract-plugin
module.exports = {"animation-group":"ProfessionalServices_animation-group__f4Kke"};